export default "__VITE_ASSET__mfPDUBvX__"